import React, { useState, useEffect } from "react";
import CarButton from "../components/CarButton";

const Section8 = ({
  contenuti,
  callToAction1,
  link1,
  callToAction2,
  link2,
}) => {
    const [isMobile, setIsMobile] = useState(false);
        
       
          useEffect(() => {
            const handleResize = () => {
              setIsMobile(window.innerWidth < 992); 
            };
        
            handleResize(); 
            window.addEventListener("resize", handleResize);
        
            return () => {
              window.removeEventListener("resize", handleResize);
            };
          }, []);
  return (
    <>
      {contenuti.map((content, index) => {
        const { titolo1, titolo2, descrizione, immaginiAggiuntive } = content;
        return (
          <div
            key={index}
            className="container-fluid d-flex flex-column align-items-center justify-content-start position-relative"
            style={{
              padding: "32px 16px",
              gap: "16px",
            }}
          >
            {/* Titolo della sezione */}
            <div className="title-section text-center">
            <h2 className={`black-text ${isMobile ? 'd-block d-lg-none title-section-mobile' : 'd-none d-lg-block title-section'}`}>
                      {titolo1}
                    </h2>
                    <h2 className={`green-text ${isMobile ? 'd-block d-lg-none title-section-mobile' : 'd-none d-lg-block title-section'}`} >{titolo2}</h2>
            </div>

            <div className="container d-flex position-relative">
              <div className="row w-100">
                <div className="col-12">
                  <p
                    className="custom-text two-column-text"
                    dangerouslySetInnerHTML={{ __html: descrizione }}
                  ></p>
                </div>
              </div>
            </div>

            <div className="container py-3">
              {/* Right Image Section - 3 Images Affiancate */}
              <div className="col-12 col-md-8 d-flex flex-column flex-md-row justify-content-between align-items-center w-100">
                {immaginiAggiuntive?.map((img, index) => (
                  <div
                    key={index}
                    className="col-12 col-md-6 d-flex justify-content-center align-items-center mb-2 mb-md-0"
                  >
                    <img
                      src={img.immagine_path} 
                      alt={`Image ${index + 1}`}
                      className="img-fluid"
                      style={{ maxWidth: "100%", height: "auto" }}
                    />
                  </div>
                ))}
              </div>
            </div>

            {/* Pulsanti di navigazione */}
            <div className="d-flex justify-content-center align-items-center gap-3 mt-4">
              {/* Primo pulsante con classe btn-five */}
              <CarButton
                text={callToAction1}
                to={link1}
                customClass="btn btn-five text-uppercase"
              />

              {/* Secondo pulsante con classe btn-three */}
              <CarButton
                text={callToAction2}
                to={link2}
                customClass="btn btn-three text-uppercase"
              />
            </div>
          </div>
        );
      })}
    </>
  );
};

export default Section8;
